export const sections = [
  {
    title: "Health Insurance Plans",
    links: [
      {
        href: "https://www.manipalcigna.com/health-insurance",
        text: "Health Insurance",
      },
      {
        href: "https://www.manipalcigna.com/hospitalization-cover/manipalcigna-sarvah",
        text: "ManipalCigna Sarvah",
      },
      {
        href: "https://www.manipalcigna.com/hospitalization-cover/prohealth-insurance",
        text: "ManipalCigna ProHealth Prime",
      },
      {
        href: "https://www.manipalcigna.com/hospitalization-cover/lifetime-health",
        text: "ManipalCigna Lifetime Health",
      },
      // {
      //   href: "https://www.manipalcigna.com/hospitalization-cover/hospitalisation-plan-ph",
      //   text: "ManipalCigna ProHealth Insurance",
      // },
      {
        href: "https://www.manipalcigna.com/hospitalization-cover/super-topup",
        text: "ManipalCigna Super Top Up",
      },
      {
        href: "https://www.manipalcigna.com/hospitalization-cover/senior-citizen-health-insurance",
        text: "ManipalCigna Prime Senior",
      },
      {
        href: "https://www.manipalcigna.com/hospitalization-cover/prohealth-select",
        text: "ManipalCigna ProHealth Select",
      },
      {
        href: "https://www.manipalcigna.com/daily-hospital-cash/prohealth-cash",
        text: "ManipalCigna ProHealth Cash",
      },
      {
        href: "https://www.manipalcigna.com/hospitalization-cover/arogya-sanjeevani-policy",
        text: "Arogya Sanjeevani Policy, ManipalCigna",
      },
      {
        href: "https://www.manipalcigna.com/critical-illness-cover/lifestyle-protection-critical-care",
        text: "ManipalCigna Lifestyle Protection - Critical Care",
      },
      {
        href: "https://www.manipalcigna.com/personal-accident-cover/lifestyle-protection-accident-care",
        text: "ManipalCigna Lifestyle Protection - Accident Care",
      },
      {
        href: "https://www.manipalcigna.com/personal-accident-cover/saral-suraksha-bima",
        text: "Saral Suraksha Bima, ManipalCigna",
      },
      {
        href: "https://www.manipalcigna.com/group-insurance/prohealth-group-insurance-policy",
        text: "ManipalCigna ProHealth Group Insurance Policy",
      },
      {
        href: "https://www.manipalcigna.com/group-insurance/lifestyle-protection-group-policy",
        text: "ManipalCigna Lifestyle Protection Group Policy",
      },
      {
        href: "https://www.manipalcigna.com/group-insurance/group-overseas-travel-insurance",
        text: "ManipalCigna Group Overseas Travel Insurance Policy",
      },
      {
        href: "https://www.manipalcigna.com/group-insurance/flexicare-group-insurance-policy",
        text: "ManipalCigna FlexiCare Group Insurance Policy",
      },
      {
        href: "https://www.manipalcigna.com/group-insurance/global-health-group-policy",
        text: "ManipalCigna Global Health Group Policy",
      },
    ],
  },
  {
    title: "Website",
    links: [
      {
        href: "https://www.manipalcigna.com/privacy-policy",
        text: "Privacy Policy",
      },
      {
        href: "https://www.manipalcigna.com/terms-and-conditions",
        text: "Terms and Conditions",
      },
      { href: "https://eservicing.manipalcigna.com", text: "Customer Login" },
      {
        href: "https://eservicing.manipalcigna.com",
        text: "Register to Login",
      },
      { href: "https://www.manipalcigna.com/disclaimer", text: "Disclaimers" },
      {
        href: "https://www.manipalcigna.com/disclosures/public-disclosures",
        text: "Disclosures",
      },
      {
        href: "https://www.manipalcigna.com/disclosures/unclaimed-amount",
        text: "Unclaimed Amount",
      },
    ],
  },
  {
    title: "Services",
    links: [
      {
        href: "https://eservicing.manipalcigna.com/login",
        text: "Service Request",
      },
      {
        href: "https://www.manipalcigna.com/service-tat",
        text: "Service Turn-around-Time",
      },
      {
        href: "https://online.manipalcigna.com/quick-pay/",
        text: "Quick Payment",
      },
      {
        href: "https://online.manipalcigna.com/erenewal/renew?source=NWEB",
        text: "Renew now",
      },
      {
        href: "https://www.manipalcigna.com/claims",
        text: "Track Claim Application",
      },
      { href: "https://www.manipalcigna.com/claims", text: "Claim Process" },
      {
        href: "https://www.manipalcigna.com/si-opt",
        text: "Recurring Payment Opt Out",
      },
      { href: "https://healthie.manipalcigna.com/", text: "Create ABHA ID" },
      {
        href: "https://www.manipalcigna.com/ghd",
        text: "Online Good Health Declaration",
      },
    ],
  },
  {
    title: "About Us",
    links: [
      {
        href: "https://www.manipalcigna.com/management-team",
        text: "Management Team",
      },
      {
        href: "https://www.manipalcigna.com/press-releases",
        text: "Press Release",
      },
      { href: "https://www.manipalcigna.com/careers", text: "Careers" },
      { href: "https://www.manipalcigna.com/key-persons", text: "Key Persons" },
      {
        href: "https://www.manipalcigna.com/board-members",
        text: "Board Members",
      },
    ],
  },
  {
    title: "Partner Sites",
    links: [
      { href: "https://manipal.edu/mu.html", text: "Manipal University" },
      { href: "https://www.manipalhospitals.com/", text: "Manipal Hospitals" },
      { href: "http://www.stempeutics.com/", text: "Stempeutics Research" },
      { href: "https://www.manipalfoundation.in/", text: "Manipal Foundation" },
      { href: "https://www.cigna.com/", text: "Cigna Corporation" },
    ],
  },
  {
    title: "Compliance",
    links: [
      {
        href: "https://www.irdai.gov.in/Defaulthome.aspx?page=H1",
        text: "IRDAI Website",
      },
      { href: "https://ndnc.net/", text: "Do No Call" },
      {
        href: "https://www.manipalcigna.com/grievance-redressal",
        text: "Grievance Redressal",
      },
      {
        href: "https://www.manipalcigna.com/products-withdrawn-or-modified",
        text: "Products Withdrawn",
      },
      { href: "http://www.gicouncil.in/", text: "General Insurance Council" },
      {
        href: "https://www.manipalcigna.com/documents/d/guest/ca_final-list-as-2025",
        text: "Corporate Agents",
        download: true,
      },
      {
        href: "https://www.manipalcigna.com/uw-approach",
        text: "Underwriting Approach",
      },
      {
        href: "https://www.manipalcigna.com/documents/d/guest/blacklisted-agent-list-2025",
        text: "Blacklisted Agents",
      },
      {
        href: "https://bimabharosa.irdai.gov.in/Home/Home",
        text: "Bima Bharosa",
      },
    ],
  },
  {
    title: "Articles",
    links: [
      { href: "https://www.manipalcigna.com/blog", text: "Blogs" },
      {
        href: "https://www.manipalcigna.com/wellness/wellness-bites/family-health",
        text: "Family Health",
      },
      {
        href: "https://www.manipalcigna.com/wellness/wellness-bites/healthy-ageing",
        text: "Healthy Ageing",
      },
      {
        href: "https://www.manipalcigna.com/wellness/wellness-bites/caregiver-resources",
        text: "Caregiver Resources",
      },
      {
        href: "https://www.manipalcigna.com/wellness/wellness-bites/exercise-and-fitness",
        text: "Exercise and Fitness",
      },
    ],
  },
  {
    title: "Quick Links",
    links: [
      {
        href: "https://online.manipalcigna.com/get-quick-quote/",
        text: "Premium Calculator",
      },
      {
        href: "https://www.manipalcigna.com/downloads/products",
        text: "Downloads",
      },
      { href: "https://www.manipalcigna.com/faqs/products", text: "FAQs" },
      { href: "https://www.manipalcigna.com/learn/glossary", text: "Glossary" },
      {
        text: (
          <form action="https://www.manipalcigna.com/locate-us" method="POST">
            <input
              type="hidden"
              value="locator"
              name="locator"
              autoComplete="off"
            />
            <button className="btn hospital_loc" type="submit">
              Hospital Locator
            </button>
          </form>
        ),
      },
      {
        href: "https://www.manipalcigna.com/dematerialisation-policy-documents",
        text: "Dematerialisation Policy Documents",
      },
      { href: "https://www.manipalcigna.com/our-tpas", text: "Our TPAs" },
      {
        href: "https://www.manipalcigna.com/benefit-illustrator-prime",
        text: "Benefit Illustration",
      },
      {
        href: "https://eservicing.manipalcigna.com/document-vault",
        text: "Document Vault",
      },
    ],
  },
];
